<template>
  <div>
    <v-container> 
      <v-btn
        @click="changeView('shipping-main')"
        depressed
        small
        :outline="currentView != 'shipping-main'"
        :color="currentView == 'shipping-main' ? 'primary' : 'grey'"
      >
        {{ $t('shippin_main') }}
      </v-btn>
      <v-btn
        @click="changeView('shipping-connect')"
        depressed
        small
        :outline="currentView != 'shipping-connect'"
        :color="currentView == 'shipping-connect' ? 'primary' : 'grey'"
      >
        {{ $t('shippin_connect') }}
      </v-btn>
    </v-container>
    <component :is="currentView"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

//component
import ShippingMain from './ShippingMain.vue'
import ShippingConnect from './ShippingConnect.vue'


export default {
  data() {
    return {
      currentView:'shipping-main'
    }
  },
  components: {
    ShippingMain,
    ShippingConnect
  },
  mounted() {
    const vm = this
    let localView = localStorage.getItem('currentView')
    if(localView==='shipping-main'){
        vm.currentView = 'shipping-main'
      }
      else if(localView === 'shipping-connect'){
        vm.currentView = 'shipping-connect'
      }
      else{
        vm.currentView = 'shipping-main'
      }
  },
  computed: {
  },
  methods: {
    changeView(view){
      const vm = this;
      let setView = localStorage.setItem('currentView',view)
      vm.currentView=view
    },
    async onChangeToggleLineAutoSendOrderTrackingStatus() {
      this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
      this.$store.dispatch('loading')
      var data = {
        body: { line_auto_send_order_tracking_status: this.toggleLineAutoSendOrderTrackingStatus },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
      }
      this.$store.dispatch('loading')
    },
   
    gotoshippop() {
      this.$el.querySelector('[id="shippop"]').scrollIntoView()
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingMethod.vue